import React, {useState, useEffect, useMemo} from "react";
import CompaniesContent from "./CompaniesContent"
import InputContent from "./InputContent"
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import MuiDialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core/styles';
import InsertCSVContent from "./InsertCSVContent";
import ShopeeWithCNHInputContent from "./ShopeeWithCNHInputContent";
import ShopeeWithVehiclePlateInputContent from "./ShopeeWithVehiclePlateInputContent";

const styles = (theme) => ({
    root: {
      margin: 0,
      padding: theme.spacing(2),
    },
    closeButton: {
      position: 'absolute',
      right: theme.spacing(1),
      top: theme.spacing(1),
      color: theme.palette.grey[500],
    },
  });

const DialogTitle = withStyles(styles)((props) => {
    const { children, classes, onClose, ...other } = props;
    return (
      <MuiDialogTitle disableTypography className={classes.root} {...other}>
        <Typography variant="h6">{children}</Typography>
        {onClose ? (
          <IconButton aria-label="close" className={classes.closeButton} onClick={onClose}>
            <CloseIcon />
          </IconButton>
        ) : null}
      </MuiDialogTitle>
    );
  });

function AnalyzeDialog(props) {

    const {boxType, person_type, batchAnalysis } = props

    const [selectCompany, setSelectCompany] = useState(null)

    const [isShopeeWithCNH, setIsShopeeWithCNH] = useState(false)
    const [isShopeeWithVehiclePlate, setIsShopeeWithVehiclePlate] = useState(false)

    const shopeeWithCNHList = useMemo(() => [
        "789-789-789", // Local test CK
        "a86f0af2-1899-4886-b7ce-a71316376f06", // [Dados] KYP Drivers_SPX_L5
        "55fff671-e849-4005-a541-6baceaaccd4d", // [Dados] KYP Drivers_CPF_L3
        "41dc548c-cbd8-456b-a8ff-bf5a9ed3497d", // [Validacao] KYP Drivers_CPF_L3
        "3fc5e8a1-fe0b-4547-909d-d9728c4e83c9", // [Validacao] KYP Drivers_SPX_L5
    ], [])

    const shopeeWithVehiclePlateList = useMemo(() => [
        "baf7c52a-c6ef-44a8-9d16-9173e2636e32", // [Dados] KYP Drivers_CPF_L4
        "a74ae915-be66-4501-bcf3-6b874f87b1f6", // [Validacao] KYP Drivers_CPF_L4
        "ffded58f-6bf7-4b0a-83bc-a871fa075acb", // [Dados] KYP Drivers_SPX_L6
        "a52a9bf9-0842-484c-8221-99ad36578010", // [Validacao] KYP Drivers_SPX_L6
    ], [])


    useEffect(() => {
        if (shopeeWithCNHList.includes(selectCompany?.company_key)) {
            setIsShopeeWithCNH(true)
        }
        else {
            setIsShopeeWithCNH(false)
        }
        
        if (shopeeWithVehiclePlateList.includes(selectCompany?.company_key)) {
            setIsShopeeWithVehiclePlate(true)
        }
        else {
            setIsShopeeWithVehiclePlate(false)
        }
    }, [selectCompany, shopeeWithCNHList, shopeeWithVehiclePlateList])

    useEffect(() => {
        if (props.user_data.business_group_key){
            setSelectCompany({
                status: true
            })
        }
        else{
            setSelectCompany({
                status: false,
                company_key: props.user_data.company_key
            })
        }
    },[props.user_data])

    const handleDialogClose = () => {
        props.onClose()
        setTimeout(() => {
            if (props.user_data.business_group_key){
                setSelectCompany({
                    status: true
                })
            }
            else{
                setSelectCompany({
                    status: false,
                    company_key: props.user_data.company_key
                })
            }}, 500)
    }
    
    let dialogContent = null

    if (selectCompany === null){
        dialogContent = null
    }

    else if (isShopeeWithCNH) {
        dialogContent = <ShopeeWithCNHInputContent
            boxType={boxType}
            person_type={person_type}
            business_group_key={props.user_data.business_group_key}
            setSelectCompany={setSelectCompany} 
            setPageParams={props.setPageParams}
            company_key={selectCompany.company_key}
            dialogClose={handleDialogClose}
            local_storage_object_preffix={props.local_storage_object_preffix}
            onClose={props.onClose}
        />
    }
    else if (isShopeeWithVehiclePlate) {
        dialogContent = <ShopeeWithVehiclePlateInputContent
        boxType={boxType}
        person_type={person_type}
        business_group_key={props.user_data.business_group_key}
        setSelectCompany={setSelectCompany} 
        setPageParams={props.setPageParams}
        company_key={selectCompany.company_key}
        dialogClose={handleDialogClose}
        local_storage_object_preffix={props.local_storage_object_preffix}
        onClose={props.onClose}
        />
    }
    else if (selectCompany.status){
        dialogContent = <CompaniesContent setSelectCompany={setSelectCompany}/>
    }
    else if (batchAnalysis) {
        dialogContent = <InsertCSVContent
            companyKey={selectCompany.company_key}
            userData={props.user_data}
            person_type={props.person_type}
        />
    }
    else (
        dialogContent = <InputContent 
            boxType={boxType}
            person_type={person_type}
            business_group_key={props.user_data.business_group_key}
            setSelectCompany={setSelectCompany} 
            setPageParams={props.setPageParams}
            company_key={selectCompany.company_key}
            dialogClose={handleDialogClose}
            local_storage_object_preffix={props.local_storage_object_preffix}
            onClose={props.onClose}
        />
    )

    return (
        <Dialog 
        open={props.open} 
        onClose={handleDialogClose}
        disableBackdropClick
        keepMounted={false}>
            <DialogTitle 
                className={['blueText', "subtitleSize"].join(" ")} 
                onClose={handleDialogClose}
            >
                {boxType === "queryByName" ? "Consulta por Nome" : "Nova Análise"}
            </DialogTitle>
            <DialogContent >
                <div style={{width:"366px", minHeight: "200px", display:"flex", flexDirection:"column", marginBottom:"30px"}}>
                    {dialogContent}
                </div>
            </DialogContent>
        </Dialog>
    )
}

export default AnalyzeDialog